import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const deleteCalendarVacationOperation = async (
  calendarVacationId: number,
  setLoading: (isLoading: boolean) => void,
  onClose: () => void,
) => {
  try {
    if (!calendarVacationId || isNaN(Number(calendarVacationId))) {
      toast.error('מזהה חופשה לא תקין');
      return;
    }

    setLoading(true);
    await appApi.deleteCalendarVacation(calendarVacationId);
    await globalSettingsStores.fetchSetting();
    toast.success('החופשה נמחקה בהצלחה');
    onClose();
  } catch (e) {
    toast.error('מחיקת החופשה נכשלה, נסה שוב בעוד מספר רגעים');
    console.error(`deleteCalendarVacationOperation failed: ${e}`);
  } finally {
    setLoading(false);
  }
};
